import { ActionReducerMapBuilder, createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit"
import { initialStateData, screens } from "../data/app"
import { AppState } from "../interfaces/app"
import { ReducerAction } from "../interfaces/common"
import { proceedThunk, sendGet, sendPost } from "../utils/server/request";
import { ServerResponseEmail, ServerResponseStatus } from "../interfaces/serverResponse";
import { getCodeNumberByValue } from "../utils/promocode";
import { getParam } from "../utils/client/url";

const appAdapter = createEntityAdapter()
const initialState = appAdapter.getInitialState(initialStateData)

export const getGameStatus = createAsyncThunk('app/get-status', async (props: {
  ttl?: number
}) => {
  return proceedThunk(
    async () => await sendGet(`https://sp-api.friday.ru/sber/status`, {}, () => {
    }),
    props
  )
})

export const saveCode = createAsyncThunk('app/save-code', async (props: {
  ttl?: number,
  email: string,
  type: number
}) => {
  return proceedThunk(
    async () => await sendPost(`https://sp-api.friday.ru/sber/code-n`, { email: props.email, type: props.type }, () => {
    }),
    props
  )
})


export const saveUserData = createAsyncThunk('app/save-email', async (props: {
  ttl?: number,
  email: string,
  name: string
}) => {
  return proceedThunk(
    async () => await sendPost(`https://sp-api.friday.ru/sber/email`, { email: props.email, name: props.name }, () => {
    }),
    props
  )
})

function successScreen(currentScreen: number) {
  if(currentScreen === screens.EMPTY) {
    return screens.WELCOME
  }
  return  screens.RULES
}

const appSliceData = {
  name: 'app',
  initialState,
  reducers: {
    setScreen(state: AppState, action: ReducerAction<number>) {
      state.screen = action.payload
    },
    setEmail(state: AppState, action: ReducerAction<string>) {
      state.email = action.payload
    },
    setUserName(state: AppState, action: ReducerAction<string>) {
      state.username = action.payload
    },
    toggleAgreed(state: AppState) {
      state.agreed = !state.agreed
    },
    setShowRules(state: AppState, action: ReducerAction<boolean>) {
      state.showRules = action.payload
    },
    setConfirm(state: AppState, action: ReducerAction<boolean>) {
      state.showConfirm = action.payload
    },
    incrementCodeShown(state: AppState) {
      if (state.code < 2) {
        state.code++
      }
    },
    incrementCounter(state: AppState) {
      state.count++
    }
  },
  extraReducers: (builder: ActionReducerMapBuilder<AppState>): void => {
    builder
      .addCase(getGameStatus.fulfilled, (state: AppState, action: ReducerAction<ServerResponseStatus>) => {
        const t = getParam('t')

        if (t === 's51') {
          state.screen = screens.RULES // todo remove!!!
          if (action.payload.game_status === 'ended') {
            state.screen = screens.STUB
            document.querySelector('html')?.classList.add('ended')
          } else if (action.payload.game_status === 'ok') {
            state.screen = successScreen(state.screen)
          }
        } else {
          if (action.payload.game_status === 'ended') {
            state.screen = screens.STUB
            document.querySelector('html')?.classList.add('ended')
          } else if (action.payload.game_status === 'ok') {
            state.screen = successScreen(state.screen)
          } else {
            state.screen = screens.FINISHED_NO_TEXT
          }
        }
      })
      .addCase(saveUserData.fulfilled, (state: AppState, action: ReducerAction<ServerResponseEmail>) => {
        if (action.payload.code !== '') {
          state.showAlreadyHave = true
          state.codeText = action.payload.code
          state.code = getCodeNumberByValue(action.payload.value)
        } else {
          state.screen = screens.GAME
        }
      })
      .addCase(saveCode.fulfilled, (state: AppState) => {
        if (state.code < 3) { // убираем попап
          state.code++
        }
        state.screen = screens.DONE
      })
  }
}

const appSlice = createSlice(appSliceData)

export const {
  incrementCodeShown,
  setShowRules,
  setConfirm,
  incrementCounter,
  setScreen,
  setUserName,
  setEmail,
  toggleAgreed
} = appSlice.actions
export default appSlice.reducer